:host {
  --aha-slider--handle-size: 16px;
  --aha-slider--handle-color: var(--aha-blue-500);
  --aha-slider--handle-border-radius: 50%;
  --aha-slider--handle-margin-top: -6px;
  --aha-slider--tick-size: 16px;
  --aha-slider--track-height: 10px;
  --aha-slider--track-color-left: var(--aha-blue-400);
  --aha-slider--track-color-right: var(--aha-blue-100);
  --aha-slider--displacement: -11px;
  --aha-slider--track-border-radius: var(--Common--border-radius);
  --aha-slider--unit-label-background-color: none;
  --aha-slider--unit-label-padding-vertical: 0;
  --aha-slider--unit-label-padding-horizontal: 0;
  width: 100%;
}

.aha-slider__layout {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--spacer-1);
}

.aha-slider__container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.aha-slider__info {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.aha-slider__info div {
  display: flex;
}

.aha-slider__ticks-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
}

.aha-slider__tick {
  width: var(--aha-slider--tick-size);
  height: var(--aha-slider--tick-size);
  border-radius: 50%;
  background-color: var(--theme-tertiary-background);
}

.aha-slider__info-unit-label {
  padding: var(--aha-slider--unit-label-padding-vertical)
    var(--aha-slider--unit-label-padding-horizontal);
  background-color: var(--aha-slider--unit-label-background-color);
  border-radius: 5px;
}

input[type='range'] {
  --aha-slider--value: 50;
  -webkit-appearance: none;
  display: inline-flex;
  position: relative;
  margin: 0;

  width: 100%;
  height: var(--aha-slider--track-height);

  outline: none;
  background: linear-gradient(
    to right,
    var(--aha-slider--track-color-left) 0%,
    var(--aha-slider--track-color-left) calc(1% * var(--aha-slider--value)),
    var(--aha-slider--track-color-right) calc(1% * var(--aha-slider--value)),
    var(--aha-slider--track-color-right) 100%
  );
  border-radius: var(--aha-slider--track-border-radius);

  z-index: 10;
}

input[type='range']::-webkit-slider-thumb {
  -webkit-appearance: none;
  height: var(--aha-slider--handle-size);
  width: var(--aha-slider--handle-size);
  border-radius: 50%;

  background: var(--aha-slider--handle-color);
  cursor: pointer;
}

input[type='range']::-moz-range-thumb {
  height: var(--aha-slider--handle-size);
  width: var(--aha-slider--handle-size);
  border-radius: 50%;

  background: var(--aha-slider--handle-color);
  cursor: pointer;
}

input[type='range']::-ms-thumb {
  margin-top: 0;

  height: var(--aha-slider--handle-size);
  width: var(--aha-slider--handle-size);
  border-radius: 50%;

  background: var(--aha-slider--handle-color);
  cursor: pointer;
}
